var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    "class": [{
      'required-field-placeholder-hint': _vm.required && !_vm.inputValue
    }, _vm.inputStyle === 'tailwind' ? 'input-style-tailwind' : ''],
    staticStyle: {
      "position": "relative"
    }
  }, [_vm.inputStyle === 'tailwind' ? [_c('div', {
    staticClass: "space-y-1.5"
  }, [_vm.label ? _c('label', {
    staticClass: "text-xs font-semibold text-slate-500 uppercase tracking-wider"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('div', {
    staticClass: "relative"
  }, [_c('input', {
    ref: "textField",
    "class": [_vm.twInputClass, _vm.errorMessages && _vm.errorMessages.length ? 'border-red-500' : ''],
    attrs: {
      "type": "text",
      "disabled": _vm.disabled,
      "placeholder": _vm.displayPlaceholder
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "input": function input($event) {
        return _vm.handleInput($event.target.value);
      },
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keydown": _vm.onKeydown
    }
  }), _vm.loading ? _c('v-progress-circular', {
    staticClass: "absolute right-3 top-1/2 transform -translate-y-1/2",
    attrs: {
      "indeterminate": "",
      "size": "20",
      "width": "2"
    }
  }) : _vm._e()], 1), _vm.errorMessages && _vm.errorMessages.length ? _c('p', {
    staticClass: "text-xs text-red-600"
  }, [_vm._v(_vm._s(_vm.errorMessages[0]))]) : _vm._e()])] : _c('v-text-field', {
    ref: "textField",
    attrs: {
      "disabled": _vm.disabled,
      "error-messages": _vm.errorMessages,
      "label": _vm.label,
      "placeholder": _vm.displayPlaceholder,
      "persistent-placeholder": _vm.required,
      "dense": _vm.dense,
      "outlined": _vm.outlined,
      "clearable": _vm.clearable,
      "loading": _vm.loading,
      "hide-details": "auto"
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keydown": _vm.onKeydown
    },
    model: {
      value: _vm.inputValue,
      callback: function callback($$v) {
        _vm.inputValue = $$v;
      },
      expression: "inputValue"
    }
  }), _vm.showSuggestion && _vm.companyData ? _c('div', {
    staticClass: "suggestion-dropdown",
    staticStyle: {
      "position": "absolute",
      "top": "100%",
      "left": "0",
      "right": "0",
      "z-index": "1000",
      "background": "white",
      "border": "1px solid #ccc",
      "border-radius": "4px",
      "box-shadow": "0 2px 8px rgba(0,0,0,0.15)",
      "min-width": "400px",
      "max-width": "600px"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    style: {
      cursor: 'pointer',
      padding: '12px 16px',
      backgroundColor: _vm.isHovered ? '#f5f5f5' : 'white'
    },
    on: {
      "click": _vm.selectCompany,
      "mouseenter": function mouseenter($event) {
        _vm.isHovered = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.isHovered = false;
      }
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticStyle: {
      "font-weight": "500",
      "margin-bottom": "4px"
    }
  }, [_vm._v(" " + _vm._s(_vm.companyData.name) + " ")]), _c('v-list-item-subtitle', {
    staticStyle: {
      "font-size": "0.8rem",
      "color": "#666",
      "line-height": "1.4"
    }
  }, [_vm.companyData.siren ? _c('div', {
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_c('strong', [_vm._v("SIREN:")]), _vm._v(" " + _vm._s(_vm.companyData.siren) + " ")]) : _vm._e(), _vm.companyData.line1 || _vm.companyData.line2 || _vm.companyData.city || _vm.companyData.postal_code || _vm.companyData.country ? _c('div', {
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_c('strong', [_vm._v("Adresse:")]), _vm.companyData.line1 ? _c('span', [_vm._v(_vm._s(_vm.companyData.line1))]) : _vm._e(), _vm.companyData.line2 ? _c('span', [_vm._v(", " + _vm._s(_vm.companyData.line2))]) : _vm._e(), (_vm.companyData.line1 || _vm.companyData.line2) && (_vm.companyData.city || _vm.companyData.postal_code) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm.companyData.city ? _c('span', [_vm._v(_vm._s(_vm.companyData.city))]) : _vm._e(), _vm.companyData.postal_code ? _c('span', [_vm._v(" " + _vm._s(_vm.companyData.postal_code))]) : _vm._e(), _vm.companyData.country && (_vm.companyData.city || _vm.companyData.postal_code) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm.companyData.country ? _c('span', [_vm._v(_vm._s(_vm.companyData.country))]) : _vm._e()]) : _vm._e(), _vm.companyData.vat_number ? _c('div', {
    staticStyle: {
      "margin-bottom": "2px"
    }
  }, [_c('strong', [_vm._v("TVA:")]), _vm._v(" " + _vm._s(_vm.companyData.vat_number) + " ")]) : _vm._e()])], 1)], 1)], 1)], 1) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }